import React, { memo, useCallback, useRef, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchPostStation, getOperatorStations } from "Slices/operatorStation";
import { getIsStopsByCurrentSemanticMapEmpty } from "Slices/stops";
import { useOnClickOutside } from "Utils/hooks";

import { ReactComponent as SelectIcon } from "Components/common/assets/selectIconBold.svg";

import {
  HeadingStyled,
  StationSelectionWrapperStyled,
  StationSelectorDropdownStyled,
  CurrentItemStyled,
  DropdownContentStyled,
  DropdownItemStyled,
} from "./styles";

const StationPicker = memo(() => {
  const dispatch = useDispatch();
  const stations = useSelector(getOperatorStations);
  const isStopsEmpty = useSelector(getIsStopsByCurrentSemanticMapEmpty);

  const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
  const [showDropdown, setShowDropdown] = useState(false);
  const noStationsAvailable = useMemo(() => {
    return isStopsEmpty;
  }, [isStopsEmpty]);

  const handleClickOutside = useCallback(() => {
    setShowDropdown(false);
  }, []);
  useOnClickOutside(ref, handleClickOutside);

  const { selectedStation, selectedStationId } = useMemo(() => {
    const station = stations.find((each) => each.isPicked);
    return {
      selectedStationId: station?.id,
      selectedStation: station?.name,
    };
  }, [stations]);

  return (
    <>
      {!selectedStation && <HeadingStyled>no stations selected</HeadingStyled>}
      <StationSelectionWrapperStyled
        hasSelection={!!selectedStationId}
        isDisabled={noStationsAvailable}
        ref={ref}
      >
        <StationSelectorDropdownStyled
          onClick={() => {
            setShowDropdown(!showDropdown);
          }}
          active={showDropdown}
        >
          <CurrentItemStyled hasSelection={!!selectedStation}>
            {selectedStation
              ? selectedStation
              : noStationsAvailable
              ? "No stations found"
              : "Select a station >"}
          </CurrentItemStyled>
          {!noStationsAvailable && selectedStation && <SelectIcon />}
        </StationSelectorDropdownStyled>
        {!noStationsAvailable && showDropdown && (
          <DropdownContentStyled>
            {stations.map((station) => {
              const { id, name } = station;
              return (
                <DropdownItemStyled
                  key={id}
                  onClick={() => {
                    if (id !== selectedStationId) {
                      dispatch(fetchPostStation({ stopId: id ?? "" }));
                    }
                    setShowDropdown(false);
                  }}
                >
                  {name}
                </DropdownItemStyled>
              );
            })}
          </DropdownContentStyled>
        )}
      </StationSelectionWrapperStyled>
    </>
  );
});
export default StationPicker;
